module.exports = __webpack_public_path__ + "img/newCycle.04ff9a0d.png";